import PosLayout from "../components/layouts/posLayout.comp";
import PosShopSelector from "../components/setting/posShopSelector";
import ProfileLocale from "../components/setting/profileLocale";
import ProfileMe from "../components/setting/profileMe";
import ProfilePaymentOptions from "../components/setting/profilePaymentOptions";
import { useTranslation } from "../core/translation.core";

export default function SettingPage() {
  return (
    <PosLayout title="Setting Page">
      <Content />
    </PosLayout>
  );
}
function Content() {
  const { msg, t } = useTranslation();

  return (
    <section className="m-1 lg:m-6 space-y-10">
      <h1 className="text-3xl dark:text-white">{t(msg.setting.posSetting)}</h1>
      <div className="p-6 bg-white dark:bg-her-darkblue2 rounded-lg shadow-md space-y-10">
        <ProfileMe />
        <ProfileLocale />
        <PosShopSelector />
        <ProfilePaymentOptions />
      </div>
    </section>
  );
}
